import type { TrackingInfo } from "@/components/amc-pixel/amc-pixel-types";

/**
 * Function to get tracking info from the AMC Pixel.
 * Only available after the AMC Pixel has loaded on the client side.
 * On the server side, it will return an empty object.
 */
export const getTrackingInfo = (): Promise<TrackingInfo> => {
  if (typeof window === "undefined") {
    return Promise.resolve({});
  }

  if (typeof window.getTrackingInfo === "function") {
    return Promise.resolve(window.getTrackingInfo());
  }

  return new Promise((resolve, reject) => {
    let timeoutId: number | undefined;

    const controller = new AbortController();
    // @ts-ignore
    window.addEventListener(
      "trackingInfoReady",
      (event: CustomEvent<TrackingInfo>) => {
        clearTimeout(timeoutId);
        resolve(event.detail);
      },
      { once: true, signal: controller.signal },
    );

    timeoutId = window.setTimeout(() => {
      controller.abort();
      reject(new Error("AMC Pixel took too long to load."));
    }, 10000);
  });
};
